<template>
    <div class="float-left">
        <b-button
        variant="success"
        @click="abrirModal()">
            Adicionar Parecer Financeiro
        </b-button>
        <parecer-financeiro-form
            operacaoProp="I"
            :pleito="pleito"
            :mostrarModal="mostrarModal"
            :erros="erros"
            :dataServicos="dataServicos"
            @fechar="fecharModal()"
            @salvar="salvar($event)"
        ></parecer-financeiro-form>
    </div>
</template>

<script>
import ParecerFinanceiroForm from './ParecerFinanceiroForm'

export default {
    components: {
        ParecerFinanceiroForm
    },

    props: {
        pleito: {
            type: Object,
        },
        dataServicos: {
            type: Object
        },
    },

    data() {
        return {
            mostrarModal: false,
            erros: [],
        }
    },

    methods: {
        abrirModal() {
            this.mostrarModal = true
        },

        fecharModal() {
            this.mostrarModal = false
        },

        salvar(parecer){
            this.$store.dispatch('addRequest')
            let parecerDto = {
                pleitoId : parecer.pleitoId,
                justificativa: parecer.justificativa,
            }
            this.dataServicos.inserirParecerFinanceiro(parecerDto)
            .then(response => {
                if (response) {
                    if (response.success) {
                        this.$toast.success(
                            'Parecer Financeiro inserido com sucesso',
                            'OK',
                            this.$toastConfig.success)
                        this.$emit('atualizarLista')
                    } else {
                        this.erros = response.errors
                    }
                }
                this.$store.dispatch('removeRequest')
            })
            this.fecharModal()
        },
    }
}
</script>
